import axios from 'axios'
import humps from 'humps'
import type { PayloadEnv } from '~~/types'
/**
 * Fetches the list of webview workflow runs from the GitHub Actions API with optional status filtering.
 * @returns {Promise<object>} The response containing the list of workflow runs or an error message.
 */

export default async function getListWorkflowWebview(env: PayloadEnv, query?: object) {
  const { githubActionToken } = useRuntimeConfig().public
  const token = githubActionToken
  let id = ''
  switch (env) {
    case 'ballbot':
      id = 'playwright-vendor-webview-ballbot.yml'
      break
    case 'venus':
      id = 'playwright-vendor-webview-venus.yml'
      break
    case 'production':
      id = 'playwright-vendor-webview-prod.yml'
      break
    case 'prod-support':
      id = 'playwright-vendor-webview-prod-support.yml'
      break
    default:
      id = 'playwright-vendor-webview-ballbot.yml'
      break
  }
  const url = `https://api.github.com/repos/hungryhub-team/hhvendor-automation/actions/workflows/${id}/runs`

  if (!token) {
    return {
      status: 'error',
      message: 'GITHUB_ACTION_TOKEN is not set in the .env file.',
    }
  }

  try {
    const response = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: 'application/vnd.github.v3+json',
      },
      params: {
        ...(typeof query === 'object' && query !== null ? query : {}),
      },
    })

    return {
      success: true,
      data: humps.camelizeKeys(response.data),
    }
  } catch (error) {
    const errResponse = (error as any).response
    return {
      success: false,
      message: errResponse?.data?.message || (error as Error).message || 'An unknown error occurred.',
    }
  }
}
